<template>
    <svg version="1.1" id="play" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="70px" width="70px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
        <path
            class="stroke-solid"
            fill="none"
            :stroke="color.secondary"
            d="M49.9,2.5C23.6,2.8,2.1,24.4,2.5,50.4C2.9,76.5,24.7,98,50.3,97.5c26.4-0.6,47.4-21.8,47.2-47.7
    C97.3,23.7,75.7,2.3,49.9,2.5" />
        <path
            class="icon"
            :fill="color.secondary"
            d="M38,69c-1,0.5-1.8,0-1.8-1.1V32.1c0-1.1,0.8-1.6,1.8-1.1l34,18c1,0.5,1,1.4,0,1.9L38,69z" />
    </svg>
</template>

<script>
export default {
    name: 'PlayButton',
    props: {
        color: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>

// Spin animation
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.stroke-solid {
    stroke-dashoffset: 0;
    stroke-dashArray: 300;
    stroke-width: 4px;
    transition: stroke-dashoffset 1s ease,
        opacity 1s ease;
}

.icon {
    transform: scale(.8);
    transform-origin: 50% 50%;
    transition: transform 200ms ease-out;
}

// Hover
#play:hover {
    .stroke-solid {
        opacity: 1;
        stroke-dashoffset: 300;
    }

    .icon {
        transform: scale(.9);
    }
}

#play {
    cursor: pointer;
    position: relative;
}
</style>
